























































































import FinanceBanner from './finance-banner.vue';
import FinanceVsCard from './finance-vs-card.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 *
 */
interface DataStructure {
    /**
     *
     */
    项目动态总投资: number;
    /**
     *
     */
    年销售收入: number;
    /**
     *
     */
    平均年总成本费用: number;
    /**
     *
     */
    总投资收益率: number;
    /**
     *
     */
    资本金利润率: number;
    /**
     *
     */
    资本金内部收益率: number;
    /**
     *
     */
    所得税前投资内部收益率: number;
    /**
     *
     */
    所得税前投资财务净现值: number;
    /**
     *
     */
    所得税前投资回报期: number;
    /**
     *
     */
    所得税后投资内部收益率: number;
    /**
     *
     */
    所得税后投资财务净现值: number;
    /**
     *
     */
    所得税后投资回报期: number;
}

/**
 *
 */
@Component({ components: { 'finance-banner': FinanceBanner, 'finance-vs-card': FinanceVsCard } })
export default class FinanceContainer extends Vue {
    /** */
    @Prop({ type: Boolean, default: false, required: false })
    flag!: boolean;

    /** */
    @Prop({ default: {} })
    data!: DataStructure;

    /** */
    @Prop({ default: {} })
    relatedData!: DataStructure;

    /** */
    banners(data: DataStructure): Array<{
        bannerColor: string;
        bannerTitle: string;
        bannerPrice: string | number;
        contextTitle: string;
        unit: string;
        contextPrice: string | number;
    }> {
        return [
            {
                bannerColor: 'linear-gradient(135deg, #68c9f6, #566df3)',
                bannerTitle: '工程动态投资（万元）',
                bannerPrice: data.项目动态总投资.toFixed(2),
                contextTitle: '年销售收入',
                unit: '(万元)',
                contextPrice: data.年销售收入.toFixed(2),
            },
            {
                bannerColor: 'linear-gradient(135deg, #78edd7, #338cc0)',
                bannerTitle: '总投资收益率（%）',
                bannerPrice: data.总投资收益率.toFixed(2),
                contextTitle: '平均年总成本费用',
                unit: '(万元)',
                contextPrice: data.平均年总成本费用.toFixed(2),
            },
            {
                bannerColor: 'linear-gradient(135deg, #eed472, #e7ae48)',
                bannerTitle: '资本金利润率(%)',
                bannerPrice: data.资本金利润率.toFixed(2),
                contextTitle: '资本金内部收益率',
                unit: '(%)',
                contextPrice: data.资本金内部收益率.toFixed(2),
            },
        ];
    }

    /** */
    vsCards(data: DataStructure): Array<{
        title: string;
        preValue: string | number;
        preDesc: string;
        postValue: string | number;
        postDesc: string;
    }> {
        return [
            {
                title: '项目投资内部收益率(%)',
                preValue: data.所得税前投资内部收益率.toFixed(2),
                preDesc: '所得税前',
                postValue: data.所得税后投资内部收益率.toFixed(2),
                postDesc: '所得税后',
            },
            {
                title: '净现值(万元)',
                preValue: data.所得税前投资财务净现值.toFixed(2),
                preDesc: '所得税前',
                postValue: data.所得税后投资财务净现值.toFixed(2),
                postDesc: '所得税后',
            },
            {
                title: '投资回报期(年)',
                preValue: data.所得税前投资回报期.toFixed(2),
                preDesc: '所得税前',
                postValue: data.所得税后投资回报期.toFixed(2),
                postDesc: '所得税后',
            },
        ];
    }
}
